import React, { useState, useRef } from 'react';
import ReactDOM from "react-dom";
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import Button from "../components/Button";
import CreateAdditionalDocumentModal from '../modals/CreateAdditionalDocumentModal';
import { toast } from 'react-toastify';
import ArchiveAdditionalDocumentModal from '../modals/ArchiveAdditionalDocumentModal';

const AdditionalDocumentsDataTable = ({can}) => {
    const dataTableRef = useRef(null);

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [documentForArchive, setDocumentForArchive] = useState(null);

    const renderDeleteButton = (row) => {
        return (
            <td>
                <div className="d-flex justify-content-end align-content-center align-items-center">
                    <button
                        className={"btn btn-danger"}
                        onClick={() => setDocumentForArchive(row)}
                        disabled={!row.can['delete']}
                    >
                        <span>Delete</span>
                    </button>
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card classes={"mh-100 border-0"} noPadding={true}>
                {can['create'] && (
                    <div className={"row m-0 mb-4 p-0 d-flex justify-content-lg-between"}>
                        <div className="col-12 m-0 p-0">
                            <div className={"d-flex justify-content-end"}>
                                <Button
                                    onClick={() => setShowCreateModal(true)}
                                    label={"Create Additional Document"}
                                    icon={"far fa-plus-circle"}
                                    classes={"ml-4 btn btn-eh-lilac px-3 m-0"}
                                />
                            </div>
                        </div>
                    </div>
                )}
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.additional-documents.data-table').toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="additional documents" />}
                                fieldsToExclude={[
                                    'id',
                                    'additional_document_id',
                                    'uuid',
                                    'can'
                                ]}
                                alwaysShowPagination
                                fieldMap={{
                                    url: "Thumbnail",
                                    file_name: "File Name",
                                    user_name: "Uploaded By",
                                    created_at: "Created At",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'created_at'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderDeleteButton(row)}
                                disallowOrderingBy={[
                                    'url'
                                ]}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'url':
                                            return (
                                                <div className="p-2 d-flex justify-content-center align-content-center align-items-center">
                                                    <img
                                                        src={value}
                                                        width={80}
                                                    />
                                                </div>
                                            )
                                        default:
                                            return <span>{value}</span>;
                                    }
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <CreateAdditionalDocumentModal
                show={showCreateModal}
                parentId={'additional-documents-datatable'}
                onCancel={() => setShowCreateModal(false)}
                onSuccess={() => {
                    setShowCreateModal(false);
                    dataTableRef.current.reload();
                    toast.success(<div>{"Additional Document created."}</div>);
                }}
            />
            {documentForArchive !== null && (
                <ArchiveAdditionalDocumentModal
                    show={!!documentForArchive}
                    additionalDocument={documentForArchive}
                    parentId={'additional-documents-datatable'}
                    onCancel={() => setDocumentForArchive(null)}
                    onSuccess={() => {
                        setDocumentForArchive(null);
                        dataTableRef.current.reload();
                        toast.success(<div>{"Additional Document deleted."}</div>);
                    }}
                />
            )}
        </React.Fragment>
    );
}

export default AdditionalDocumentsDataTable;

const target = document.getElementById('additional-documents-datatable');
if (target) {
    ReactDOM.render(<AdditionalDocumentsDataTable
        can={JSON.parse(target.dataset.can)}
    />, target);
}
